// src/app/core/shared/costing-data.store.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type CostGroupKey =
    | 'Health Sector Cost'
    | 'Awareness raising'
    | 'Screening Corner'
    | 'Active search'
    | 'Caring for all protocol'
    | 'Remote training'
    | 'Risk stratification tool'
    | 'PAP card'
    | 'Adherence combo'
    | 'Governance model'
    | 'Management panel'
    // Optional groups you listed but not in reference payload block:
    | 'Social Cost'
    | 'QALYs Calculation';

export type CostingValues = Record<CostGroupKey, Record<string, number>>;

@Injectable({ providedIn: 'root' })
export class CostingDataStore {
    // Initialize with defaults; can start empty and filled from CostingDataComponent
    private subject = new BehaviorSubject<Partial<CostingValues>>({});

    setGroupValues(group: CostGroupKey, values: Record<string, number>) {
        const cur = { ...this.subject.value };
        cur[group] = values;
        this.subject.next(cur);
    }

    getValues$() { return this.subject.asObservable(); }
    getValues() { return this.subject.value; }
}